import { createContext, useCallback, useContext, useMemo, useState } from "react"

const STORAGE_KEY = "hivehook_api_key"

interface AuthContextValue {
  apiKey: string
  setApiKey: (key: string) => void
  clearApiKey: () => void
  isConfigured: boolean
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuthProvider(): AuthContextValue {
  const [apiKey, setApiKeyState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) ?? ""
  })

  const setApiKey = useCallback((key: string) => {
    setApiKeyState(key)
    localStorage.setItem(STORAGE_KEY, key)
  }, [])

  const clearApiKey = useCallback(() => {
    setApiKeyState("")
    localStorage.removeItem(STORAGE_KEY)
  }, [])

  return useMemo(
    () => ({
      apiKey,
      setApiKey,
      clearApiKey,
      isConfigured: apiKey.length > 0,
    }),
    [apiKey, setApiKey, clearApiKey],
  )
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error("useAuth must be used within AuthContext.Provider")
  }
  return ctx
}
